import {
  trackBaseTemplateHeroCommunityCtaGA,
  trackBaseTemplateUIGA,
} from "@/lib/analytics";
import {
  trackBaseTemplateUIClickPostHog,
  type BaseTemplateAnalyticsName,
  type BaseTemplateClickSurface,
} from "@/lib/posthogAnalytics";

export type { BaseTemplateAnalyticsName, BaseTemplateClickSurface };

export function trackBaseTemplateClick(params: {
  templateName: BaseTemplateAnalyticsName;
  elementId: string;
  label: string;
  surface: BaseTemplateClickSurface;
  href?: string;
  countryCode?: string;
  extra?: Record<string, string | number | boolean | undefined>;
}) {
  trackBaseTemplateUIClickPostHog({
    templateName: params.templateName,
    elementId: params.elementId,
    label: params.label,
    surface: params.surface,
    href: params.href,
    countryCode: params.countryCode,
    extra: params.extra,
  });
  if (
    params.surface === "hero" &&
    params.elementId === "hero_cta_community"
  ) {
    trackBaseTemplateHeroCommunityCtaGA({
      templateName: params.templateName,
      label: params.label,
      href: params.href,
      extra: params.extra as Record<string, unknown> | undefined,
    });
  }
  trackBaseTemplateUIGA({
    templateName: params.templateName,
    elementId: params.elementId,
    label: params.label,
    surface: params.surface,
    href: params.href,
    extra: params.extra as Record<string, unknown> | undefined,
  });
}
